var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "black",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85502 11.5332L10.1883 8.18599C10.3832 7.99032 10.3825 7.67374 10.1868 7.47888C9.99117 7.28403 9.67459 7.28469 9.47974 7.48035L5.89467 11.0804C5.64418 11.3319 5.5 11.6556 5.5 11.9998C5.5 12.3441 5.64418 12.6678 5.89467 12.9193L9.47974 16.5193C9.67459 16.715 9.99118 16.7156 10.1868 16.5208C10.3825 16.3259 10.3832 16.0094 10.1883 15.8137L6.92141 12.5332L18 12.5332C18.2761 12.5332 18.5 12.3093 18.5 12.0332C18.5 11.757 18.2761 11.5332 18 11.5332L6.85502 11.5332Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutral);
export default __webpack_public_path__ + "static/media/Neutral.803e0619665419578ebc570fe14d816a.svg";
export { ForwardRef as ReactComponent };